const otherFields = {
    notes:{default:"",label:"",width:12,multiline:true,rows:4},
}

export default otherFields